module.exports = __webpack_public_path__ + "img/send_sms_hover.3c819b51.svg";